var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSicon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8462 12C13.8802 12 16.3397 9.57483 16.3397 6.58329C16.3397 3.59175 13.8802 1.16663 10.8462 1.16663C7.81228 1.16663 5.35278 3.59175 5.35278 6.58329C5.35278 9.57483 7.81228 12 10.8462 12Z",
    stroke: "#20AEF3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2412 16.3333H21.8333M16.3399 22.8333H3.44786C3.13625 22.8333 2.82819 22.768 2.54413 22.6417C2.26006 22.5154 2.00649 22.331 1.80024 22.1007C1.59398 21.8704 1.43977 21.5994 1.34783 21.3059C1.25589 21.0123 1.22832 20.7028 1.26696 20.3979L1.69545 17.0136C1.7951 16.2273 2.18262 15.504 2.78516 14.9798C3.3877 14.4555 4.16374 14.1663 4.96735 14.1666H5.35299L16.3399 22.8333ZM18.5373 13.0833V19.5833V13.0833Z",
    stroke: "#20AEF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicon4);
export default __webpack_public_path__ + "static/media/sicon4.844cdc13ad7c5b1d18e2a39b70ea329d.svg";
export { ForwardRef as ReactComponent };